"use strict";

import angular from "angular";
import "angular-material";
import "angular-basic-app";

import "angular-material/angular-material.css";

export default angular
    .module("angular-material-app", ['angular-basic-app', 'ngMaterial']);